import bindTriggers from './features/triggers.js';

bindTriggers();
